import { render, staticRenderFns } from "./right-selector.vue?vue&type=template&id=70eb0684&scoped=true"
import script from "./right-selector.vue?vue&type=script&lang=js"
export * from "./right-selector.vue?vue&type=script&lang=js"
import style0 from "./right-selector.vue?vue&type=style&index=0&id=70eb0684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb0684",
  null
  
)

export default component.exports